import { ReactNode } from "react";

export type NoticeTone = "info" | "error";

const TONE_CLASS: Record<NoticeTone, string> = {
  info: "border-oat-200 bg-white text-soil",
  error: "border-red-200 bg-red-50 text-red-800",
};

/** An inline message that sits within a screen rather than interrupting
 * it. Errors announce themselves to assistive tech; info does not. */
export default function NoticeBanner({
  tone = "info",
  children,
}: {
  tone?: NoticeTone;
  children: ReactNode;
}) {
  return (
    <div
      role={tone === "error" ? "alert" : "status"}
      className={`rounded-xl border px-4 py-3 text-base leading-snug ${TONE_CLASS[tone]}`}
    >
      {children}
    </div>
  );
}
